export default {
    autoBind: {
        type: String,
        default: undefined
    },
    axisDefaults: {
        type: Object,
        default: undefined
    },
    categoryAxis: {
        type: [Array, Object],
        default: undefined
    },
    chartArea: {
        type: Object,
        default: undefined
    },
    dataSource: {
        type: [Array, Object],
        default: undefined
    },
    legend: {
        type: Object,
        default: undefined
    },
    panes: {
        type: [Array, Object],
        default: undefined
    },
    pannable: {
        type: [Boolean, Object],
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    plotArea: {
        type: Object,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    series: {
        type: Array,
        default: undefined
    },
    seriesColors: {
        type: Array,
        default: undefined
    },
    seriesDefaults: {
        type: Object,
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    title: {
        type: [String, Object],
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined
    },
    valueAxis: {
        type: [Array, Object],
        default: undefined
    },
    xAxis: {
        type: [Array, Object],
        default: undefined
    },
    yAxis: {
        type: [Array, Object],
        default: undefined
    },
    zoomable: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    axisLabelClick: {
        type: Function,
        default: undefined
    }, 
    dataBound: {
        type: Function,
        default: undefined
    }, 
    drag: {
        type: Function,
        default: undefined
    }, 
    dragEnd: {
        type: Function,
        default: undefined
    }, 
    dragStart: {
        type: Function,
        default: undefined
    }, 
    legendItemClick: {
        type: Function,
        default: undefined
    }, 
    legendItemHover: {
        type: Function,
        default: undefined
    }, 
    noteClick: {
        type: Function,
        default: undefined
    }, 
    noteHover: {
        type: Function,
        default: undefined
    }, 
    plotAreaClick: {
        type: Function,
        default: undefined
    }, 
    plotAreaHover: {
        type: Function,
        default: undefined
    }, 
    render: {
        type: Function,
        default: undefined
    }, 
    select: {
        type: Function,
        default: undefined
    }, 
    selectEnd: {
        type: Function,
        default: undefined
    }, 
    selectStart: {
        type: Function,
        default: undefined
    }, 
    seriesClick: {
        type: Function,
        default: undefined
    }, 
    seriesHover: {
        type: Function,
        default: undefined
    }, 
    seriesOver: {
        type: Function,
        default: undefined
    }, 
    zoom: {
        type: Function,
        default: undefined
    }, 
    zoomEnd: {
        type: Function,
        default: undefined
    }, 
    zoomStart: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/ChartProps.js